module.exports = __webpack_public_path__ + "static/img/legend_xa_dark.d17a1c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xa_dark.png
// module id = i0OK
// module chunks = 94